import serializeError from 'serialize-error';
import Vue from 'vue';
import Axios from 'axios';
import store from '@/store';

Axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
Axios.defaults.headers.common.Accept = 'application/json';

const { accessToken, tokenType } = store.state.session;
if (accessToken) {
  Axios.defaults.headers.common.Authorization = `${tokenType || 'bearer'} ${accessToken}`;
}

Axios.interceptors.request.use(config => config);

Axios.interceptors.response.use(
  response => Promise.resolve(response),
  async error => {
    const { config, response } = serializeError.serializeError(error);
    const originalRequest = config;
    if (originalRequest.url === '/v1/auth/login') {
      return Promise.reject(response);
    }
    if ((response && response.status === 401) || response.status === 501) {
      const { data: json } = await Axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/v1/auth/refresh`,
      );
      if (json.error) {
        store.dispatch('session/logout');
        Vue.$router.push({ name: 'auth' });
      }
      if (json.data) {
        const { auth: tokenInfo } = json.data;
        store.dispatch('session/setToken', tokenInfo.access_token);
        store.dispatch('session/setExpiryTokenDate', tokenInfo.ttl);
        const retryOriginalRequest = new Promise((resolve) => {
          originalRequest.headers.Authorization = `bearer ${tokenInfo.access_token}`;
          resolve(Axios(originalRequest));
        });
        return retryOriginalRequest;
      }
    }
    return Promise.reject(response);
  },
);

Vue.$http = Axios;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return Axios;
  },
});

export default Vue.$http;
